import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '@styles/theme';

function HotelStyleSvg(props) {
  const { fill, width, height } = props;

  let fill1 = '#262626';
  let fill2 = '#262626';

  if (Array.isArray(fill)) {
    const [first, second] = fill;
    if (first) {
      fill1 = first;
    }
    if (second) {
      fill2 = second;
    }
  } else if (fill) {
    fill1 = fill;
    fill2 = fill;
  }

  return (
    <svg width={width || 48} height={height || 48} viewBox="0 0 48 48">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="hotelStyle">
          <g id="Group-2">
            <rect
              id="@bounds"
              x="0"
              y="1.13686838e-13"
              width="48"
              height="48"
            ></rect>
            <path
              d="M12.2102804,17.9549834 C12.879857,18.0488493 13.4061341,18.5751265 13.5,19.2447031 L14.801961,28.5320246 C14.9204603,29.3773199 15.56236,30.0542537 16.4001719,30.2174638 L22.7,31.4447031 C23.5284271,31.606085 24.0691741,32.4084837 23.9077922,33.2369108 C23.7887636,33.8479246 23.3110137,34.3256744 22.7,34.4447031 L16.4001719,35.6719423 C15.56236,35.8351524 14.9204603,36.5120862 14.801961,37.3573815 L13.5,46.6447031 C13.3838654,47.4731302 12.6181468,48.0505573 11.7897196,47.9344227 C11.120143,47.8405568 10.5938659,47.3142797 10.5,46.6447031 L9.19803903,37.3573815 C9.07953969,36.5120862 8.43763996,35.8351524 7.59982809,35.6719423 L1.3,34.4447031 C0.471572875,34.2833211 -0.0691741152,33.4809224 0.0922077922,32.6524953 C0.211236443,32.0414815 0.688986258,31.5637317 1.3,31.4447031 L7.59982809,30.2174638 C8.43763996,30.0542537 9.07953969,29.3773199 9.19803903,28.5320246 L10.5,19.2447031 C10.6161346,18.4162759 11.3818532,17.8388488 12.2102804,17.9549834 Z"
              id="shapeA"
              fill={fill1}
            ></path>
            <path
              d="M34.1666667,0.111369721 C34.8682288,0.189321068 35.4220487,0.743140936 35.5,1.44470305 L36.6618516,11.9013676 C36.8614048,13.6973458 38.2402913,15.1365007 40.0260957,15.412656 L46.7,16.4447031 C47.5284271,16.5728103 48.0961485,17.3482347 47.9680412,18.1766618 C47.8669252,18.8305453 47.3538835,19.3435871 46.7,19.4447031 L40.0260957,20.4767501 C38.2402913,20.7529054 36.8614048,22.1920603 36.6618516,23.9880385 L35.5,34.4447031 C35.4079525,35.2731302 34.6617605,35.8700838 33.8333333,35.7780364 C33.1317712,35.700085 32.5779513,35.1462652 32.5,34.4447031 L31.3381484,23.9880385 C31.1385952,22.1920603 29.7597087,20.7529054 27.9739043,20.4767501 L21.3,19.4447031 C20.4715729,19.3165958 19.9038515,18.5411714 20.0319588,17.7127443 C20.1330748,17.0588608 20.6461165,16.5458191 21.3,16.4447031 L27.9739043,15.412656 C29.7597087,15.1365007 31.1385952,13.6973458 31.3381484,11.9013676 L32.5,1.44470305 C32.5920475,0.61627593 33.3382395,0.0193222628 34.1666667,0.111369721 Z"
              id="shapeB"
              fill={fill2}
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

HotelStyleSvg.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.any
};

HotelStyleSvg.defaultProps = {
  fill: [colors.gold, colors.lightGreen]
};

export default HotelStyleSvg;
